import styled from 'styled-components';

export const ArticlePageContainer = styled.div`
	padding: 0 0 2rem;

	.container {
		max-width: 1084px;
		width: 100%;
		margin: 0 auto;
	}

	.progress-bar {
		position: sticky;
		top: 0;
		z-index: 10;
	}

	.breadcrumbs {
		margin-bottom: 2rem;
	}

	.container {
		margin-top: 2rem;
	}

	.subtitle,
	.meta {
		display: block;
		margin-bottom: 0.5rem;
		color: ${({ theme }) => theme.v3.colors.dark[0]};
	}

	.author {
		display: inline-block;

		&-image {
			overflow: hidden;
			width: 40px;
			height: 40px;
			border-radius: 50%;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		&-pos {
			display: block;
			color: ${({ theme }) => theme.v3.colors.dark[0]};
		}
	}

	.layout {
		margin-top: 2.5rem;
	}

	.content {
		flex: 1;
	}

	.sidebar {
		flex: 0 1 291px;

		&-content {
			position: sticky;
			top: 3.125rem;
		}

		&-title {
			margin-bottom: 1rem;
		}

		.copy-title {
			display: block;
			margin-bottom: 0.5rem;
			color: ${({ theme }) => theme.v3.colors.dark[0]};
		}
	}

	.toc {
		color: ${({ theme }) => theme.v3.colors.dark[0]};

		&-container {
			margin-bottom: 1rem;
		}

		&-item {
			cursor: pointer;
			transition: color 0.2s ease;

			&:hover {
				color: ${({ theme }) => theme.v3.colors.dark[8]};
			}
		}
	}
`;
